// Textos de la interfaz por idioma. "es" es la fuente completa; en "en" solo
// se define lo traducido (lo que falta hereda el español automáticamente).
// Los textos largos de marketing y contenido quedan pendientes de la
// traducción que aporta la titular (ver /app/memory/TRADUCCION-EN.md).

export const copy = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      problems: "Problemas",
      guides: "Guías",
      professionals: "Profesionales",
      about: "Sobre MideFinca",
      contact: "Contacto",
      quote: "Solicitar presupuesto",
      openMenu: "Abrir menú",
      closeMenu: "Cerrar menú",
      mainAria: "Navegación principal",
      mobileAria: "Navegación móvil",
      langAria: "Cambiar idioma",
    },
    crumbs: {
      aria: "Migas de pan",
      home: "Inicio",
      services: "Servicios",
      problems: "Problemas",
      guides: "Guías",
      prices: "Precios",
      professionals: "Profesionales",
      about: "Sobre MideFinca",
      contact: "Contacto",
    },
    common: {
      tellCase: "Cuéntanos tu caso",
      quote: "Solicitar presupuesto",
      whatsapp: "Consultar por WhatsApp",
      floatWhats: "Consultar con técnico",
      allServices: "Ver todos los servicios",
      allGuides: "Todas las guías",
      readGuide: "Leer guía",
      seePage: "Ver página",
      inPrep: "En preparación",
      priceDepLink: "Consulta de qué depende el precio de medir una finca",
      relatedServices: "Servicios relacionados",
      relatedProblems: "Problemas relacionados",
      relatedGuides: "Guías relacionadas",
      seeServices: "Ver servicios",
      // Valor de datos del formulario (no traducir: se envía al backend)
      unclearNeed: "No lo tengo claro: quiero contar mi caso",
    },
    footer: {
      tagline: "Medimos tu finca. Facilitamos tus trámites.",
      servicesH: "Servicios",
      servicesAria: "Servicios",
      problemsH: "Problemas",
      problemsAria: "Problemas frecuentes",
      companyH: "MideFinca",
      companyAria: "MideFinca",
      prices: "Precios y presupuestos",
      legal: "Aviso legal",
      privacy: "Política de privacidad",
      cookies: "Política de cookies",
      cookieSettings: "Configurar cookies",
      seeAllProblems: "Ver todos los problemas",
    },
    cta: {
      label: "Hablemos de tu caso",
      title: "¿Tienes un problema con una finca o inmueble?",
      text: "Cuéntanos tu caso y revisamos qué trabajo técnico necesitas. Sin compromiso y con presupuesto previo.",
    },
    priceCta: {
      title: "¿Quieres saber cuánto cuesta en tu caso?",
      text: "El precio depende de las características de la finca y del trabajo necesario. Envíanos la referencia catastral o la ubicación y podremos realizar una primera valoración.",
    },
    home: {
      seoT: "MideFinca | Medición de fincas, Catastro y servicios técnicos en Canarias",
      seoD: "Medimos, comprobamos y documentamos terrenos y edificaciones en Canarias: medición de fincas, GML, georreferenciación, discrepancias de Catastro, obra nueva y antigüedad.",
      kicker: "Servicios técnicos para fincas e inmuebles · Canarias",
      h1l1: "Medición y soluciones",
      h1l2: "técnicas para fincas",
      h1l3a: "e inmuebles en",
      h1l3b: "Canarias",
      intro: "Medimos, comprobamos y documentamos terrenos y edificaciones para resolver trámites de Catastro, Registro y otras gestiones relacionadas con tu inmueble.",
      imgAlt: "Técnico de MideFinca midiendo una finca con receptor GNSS en Canarias",
      geo: "CANARIAS · UTM 28R · ESPAÑA",
      probKicker: "Problemas frecuentes",
      probTitle: "Empieza por tu problema, no por el nombre del servicio",
      problems: [
        { title: "Catastro y escritura no coinciden", excerpt: "Dos cifras distintas para la misma finca. La realidad se mide.", href: "/problemas/catastro-escritura-no-coinciden/" },
        { title: "No sé dónde están los límites", excerpt: "Hitos perdidos, muros movidos, colindancias ambiguas.", href: "/problemas/no-se-donde-termina-mi-finca/" },
        { title: "Mi finca tiene más o menos metros", excerpt: "La duda no se resuelve con más documentos: se resuelve midiendo.", href: "/problemas/mi-finca-tiene-mas-o-menos-metros/" },
        { title: "Necesito un GML", excerpt: "El archivo georreferenciado que piden notaría y Registro.", href: "/problemas/necesito-gml/" },
        { title: "Comprar una finca con seguridad", excerpt: "Comprueba los metros y los límites antes de firmar.", href: "/problemas/comprar-finca-comprobar-superficie/" },
        { title: "Quiero declarar una construcción", excerpt: "Medición, planos y certificado para la obra nueva.", href: "/servicios/declaracion-obra-nueva/" },
        { title: "Ampliación no documentada", excerpt: "Tu vivienda tiene más metros de los que dicen los papeles.", href: "/problemas/construccion-no-documentada/" },
        { title: "Acreditar la antigüedad", excerpt: "Certificado técnico con evidencias históricas.", href: "/servicios/certificado-antiguedad/" },
      ],
      servKicker: "Servicios",
      fincasH: "Fincas y terrenos",
      edifH: "Edificaciones",
      procKicker: "Cómo trabajamos",
      procTitle: "Seis pasos, cero sorpresas",
      convLabel: "Presupuesto individual",
      convTitle: "¿Necesitas medir una finca o solucionar un problema con Catastro?",
      convText: "Envíanos la referencia catastral, la ubicación de la parcela o cuéntanos brevemente qué necesitas. No hace falta que conozcas el trámite o el término técnico: estudiaremos tu caso para determinar qué trabajo necesitas.",
      guidesKicker: "Guías",
      guidesH: "Entiende tu caso antes de decidir",
      faqKicker: "Preguntas frecuentes",
      faqH: "Lo que nos preguntan antes de llamar",
    },
    process: {
      steps: [
        { n: "01", title: "Cuéntanos el caso", text: "Por teléfono, WhatsApp o formulario. Si tienes referencia catastral o escritura, mejor: revisamos la información antes de comentarlo." },
        { n: "02", title: "Revisamos la información", text: "Contrastamos Catastro, cartografía y documentación disponible para entender qué ocurre y qué es necesario corregir." },
        { n: "03", title: "Te indicamos el trabajo necesario", text: "Una vez revisado tu caso, te explicamos qué trabajo técnico necesitas, qué documentación prepararemos y cuál será el alcance del encargo. Recibirás una propuesta clara junto con el presupuesto correspondiente antes de empezar." },
        { n: "04", title: "Medición y visita técnica", text: "Una vez aceptado el presupuesto y abonada la provisión de fondos o el anticipo indicado para iniciar el encargo, programamos la visita técnica cuando el trabajo lo requiera. Medimos in situ con equipos GNSS y estación total y recopilamos la información necesaria para elaborar la documentación." },
        { n: "05", title: "Elaboramos la documentación", text: "Planos, memoria, archivo GML, modificación catastral o certificado técnico, según el encargo, con los datos medidos y georreferenciados." },
        { n: "06", title: "Entrega del trabajo técnico", text: "Cuando el trabajo está terminado, te comunicamos que la documentación está preparada. Una vez abonado el importe pendiente de los honorarios, realizamos la entrega completa y te explicamos qué documentación recibes, para qué sirve y cuáles son los siguientes pasos, si los hubiera." },
      ],
    },
    trust: {
      kicker: "Por qué MideFinca",
      title: "Rigor técnico, explicado en palabras claras",
      points: [
        { title: "Arquitecto colegiado", text: "La dirección técnica la ejerce un arquitecto colegiado en el Colegio Oficial de Arquitectos de Tenerife, La Gomera y El Hierro." },
        { title: "Equipo de medición profesional", text: "Trabajamos con receptores GNSS y estación total para obtener mediciones georreferenciadas." },
        { title: "Presupuesto previo y cerrado", text: "Antes de empezar sabes qué se va a hacer, qué recibirás y cuánto cuesta. Sin sorpresas." },
        { title: "Documentación técnica profesional", text: "Planos, memorias, archivos GML y certificados elaborados con criterio técnico, no plantillas genéricas." },
        { title: "Trabajo real en Canarias", text: "Conocemos el territorio, la cartografía insular y la casuística de Catastro en Canarias." },
        { title: "Sin promesas vacías", text: "Te decimos qué es viable y qué depende de terceros. Si tu caso no tiene recorrido técnico, te lo contamos antes de cobrarte nada." },
      ],
    },
    need: {
      kicker: "¿Qué necesitas resolver?",
      knowT: "Sé qué necesito",
      knowText: "Conoces el servicio: una medición, un GML, un certificado. Elige directamente.",
      probT: "Tengo un problema",
      probText: "No sabes qué servicio hace falta. Cuéntanos qué te pasa y te orientamos.",
      probLink: "No sé qué necesito: cuento mi caso",
    },
    marquee: {
      items: [
        "Medición de fincas",
        "Catastro",
        "Georreferenciación",
        "Archivos GML",
        "Linderos y deslindes",
        "Obra nueva",
        "Certificado de antigüedad",
        "Habitabilidad",
        "Levantamientos topográficos",
        "Registro de la Propiedad",
      ],
    },
    thanks: {
      seoT: "Hemos recibido tu caso | MideFinca",
      seoD: "Hemos recibido tu consulta. La revisamos y te contactamos lo antes posible.",
      h1: "Hemos recibido tu caso",
      text: "Revisamos la información que nos has enviado, incluida la referencia catastral si la has indicado, y te contactamos para confirmarte qué trabajo técnico necesita tu caso y su presupuesto.",
      urgent: "Si es urgente, puedes llamarnos o escribirnos directamente:",
      back: "Volver al inicio",
    },
    notFound: {
      seoT: "Página no encontrada | MideFinca",
      seoD: "No encontramos esa página. Accede a servicios, problemas frecuentes, guías o contacto.",
      h1: "No encontramos esa página",
      text: "Puede que la dirección esté mal escrita o que el contenido se haya movido. Esto es lo que la mayoría de visitas busca:",
      navAria: "Destinos principales",
      links: [
        { label: "Servicios técnicos", href: "/servicios/" },
        { label: "Problemas frecuentes", href: "/problemas/" },
        { label: "Guías", href: "/guias/" },
        { label: "Contacto", href: "/contacto/" },
      ],
    },
    contact: {
      seoT: "Contacto: medición de fincas en Canarias | MideFinca",
      seoD: "Cuéntanos tu caso: medición de fincas, GML, discrepancias de Catastro, obra nueva o antigüedad en Canarias. Teléfono, WhatsApp y formulario.",
      kicker: "Contacto",
      h1: "Cuéntanos tu caso",
      intro: "No hace falta que sepas qué servicio necesitas. Describe tu problema con tus palabras y te indicamos qué trabajo técnico corresponde, con presupuesto previo y sin compromiso.",
      phoneL: "Teléfono",
      whatsNote: "Respuesta directa del técnico",
      emailL: "Email",
      areaL: "Ámbito de servicio",
      areaV: "Canarias",
      refNote: "¿Tienes la referencia catastral a mano? Inclúyela en el formulario: nos permite revisar la cartografía de tu finca antes de responderte.",
      photoAlt: "Técnica de MideFinca midiendo una finca con receptor GNSS",
    },
    form: {
      name: "Nombre",
      namePh: "Tu nombre",
      phone: "Teléfono",
      email: "Email",
      municipality: "Municipio",
      municipalityPh: "Selecciona el municipio",
      other: "Otro (fuera de Canarias)",
      need: "¿Qué necesitas?",
      needPh: "Selecciona una opción",
      message: "Cuéntanos brevemente tu caso",
      messagePh: "Ej.: Catastro indica 1.200 m² pero la escritura dice 1.500 m². Quiero vender y necesito saber la superficie real.",
      refcat: "Referencia catastral",
      optional: "(opcional)",
      attach: "Adjuntar documentación",
      attachHint: "(opcional · PDF, JPG, PNG · máx. 10 MB)",
      chooseFile: "Seleccionar archivo",
      honeypot: "No rellenar",
      privLead: "Información básica de protección de datos:",
      privResponsible: "Responsable:",
      privPurpose: "Finalidad: atender tu consulta, valorar el caso y preparar un presupuesto",
      privLegit: "Legitimación: aplicación de medidas precontractuales",
      privRecipients: "Destinatarios: no se cederán tus datos salvo obligación legal o cuando el servicio solicitado lo requiera",
      privRights: "Derechos: acceso, rectificación, supresión, oposición, limitación y portabilidad",
      privMore: "Más información en la",
      privLink: "política de privacidad",
      accept: "He leído y acepto la",
      sending: "Enviando…",
      error: "No se ha podido enviar. Inténtalo de nuevo o llámanos.",
    },
    cookies: {
      bannerAria: "Consentimiento de cookies",
      bannerA: "Utilizamos almacenamiento técnico necesario para el funcionamiento de la web y, únicamente si lo autorizas, cookies de análisis (Google Analytics 4) para medir el uso del sitio. Puedes aceptar, rechazar o configurar tu elección, y cambiarla después desde «Configurar cookies» en el pie de página. Más información en la",
      bannerLink: "política de cookies",
      accept: "Aceptar",
      reject: "Rechazar",
      configure: "Configurar",
      panelAria: "Configuración de cookies",
      panelTitle: "Configuración de cookies",
      close: "Cerrar configuración",
      techT: "Técnicas (necesarias)",
      techText: "Almacenamiento local imprescindible: recuerda tu elección sobre cookies y mantiene la sesión del panel privado de gestión. Están exentas de consentimiento.",
      alwaysOn: "Siempre activas",
      analyticsT: "Analítica",
      analyticsText: "Google Analytics 4: medición anónima de uso de la web.",
      analyticsOff: "Actualmente no hay analítica configurada: esta categoría permanece inactiva.",
      enable: "Activar",
      save: "Guardar selección",
      rejectAll: "Rechazar todo",
    },
    servicesHub: {
      seoT: "Servicios técnicos para fincas e inmuebles en Canarias | MideFinca",
      seoD: "Medición de fincas, levantamientos, georreferenciación, GML, linderos, discrepancias catastrales, obra nueva, antigüedad y habitabilidad en Canarias.",
      kicker: "Servicios",
      h1: "Servicios técnicos para fincas e inmuebles",
      intro: "Medición, Catastro y documentación técnica. Si no tienes claro cuál necesitas, cuéntanos tu problema y te orientamos sin compromiso.",
      fincasH: "Fincas y terrenos",
      edifH: "Edificaciones",
    },
    problemsHub: {
      seoT: "Problemas con fincas y Catastro: soluciones técnicas | MideFinca",
      seoD: "¿Catastro y escritura no coinciden? ¿No sabes dónde acaba tu finca? ¿Te piden un GML? Diagnóstico claro de cada problema y el trabajo técnico que lo resuelve.",
      kicker: "Problemas frecuentes",
      h1: "Empieza por tu problema",
      intro: "La mayoría de nuestros clientes no saben qué servicio necesitan: saben qué les pasa. Encuentra tu situación y te explicamos las causas, qué hay que comprobar y qué trabajo técnico corresponde.",
      ctaT: "¿No encuentras tu problema?",
      ctaX: "Cada finca es un caso. Cuéntanos el tuyo con tus palabras y te indicamos qué trabajo técnico necesitas, si lo necesitas.",
    },
    guidesHub: {
      seoT: "Guías sobre Catastro, medición y documentación de fincas | MideFinca",
      seoD: "Guías técnicas escritas en claro: superficies reales, discrepancias entre Catastro y escritura, archivos GML, linderos, obra nueva y antigüedad en Canarias.",
      kicker: "Guías",
      h1: "Guías técnicas, escritas en claro",
      introA: "Contenido técnico revisado, sin relleno. Publicamos una guía cuando está terminada y comprobada, no antes. Categorías:",
      relatedH: "También te puede interesar",
      ctaT: "¿Tu duda no está en las guías?",
      ctaX: "Pregúntanos directamente. Si es un tema recurrente, probablemente acabe convertido en guía.",
    },
    servicePage: {
      fincas: "Fincas y terrenos",
      edif: "Edificaciones",
      b1: "Cuándo necesitas este servicio",
      b2: "Qué problema resuelve",
      b3: "Qué incluye",
      b4: "Qué necesitamos para valorar tu caso",
      b5: "Qué recibirás",
      b6: "Preguntas frecuentes",
    },
    problemPage: {
      kicker: "Problema frecuente",
      answer: "La respuesta corta",
      causes: "Causas posibles",
      checks: "Qué hay que comprobar",
      pros: "Qué profesionales intervienen",
      serviceH: "El servicio de MideFinca que puede ser adecuado",
      serviceNote: "Dependerá del caso concreto: primero revisamos tu documentación y te lo confirmamos.",
    },
    guidePage: {
      updated: "Actualizada:",
      yourCase: "¿Es tu caso?",
    },
    prices: {
      seoT: "¿Cuánto cuesta medir una finca en Canarias? | MideFinca",
      seoD: "El precio de medir una finca depende de la superficie, la ubicación, la orografía y el trabajo necesario. Te explicamos de qué depende y qué necesitamos para darte un presupuesto cerrado.",
      kicker: "Precios y presupuestos",
      h1: "¿Cuánto cuesta medir una finca en Canarias?",
      intro: "Si buscas el precio de medir una finca, un terreno o una parcela en Canarias, la respuesta honesta es que no existe una tarifa única: dos fincas con la misma superficie pueden requerir trabajos muy diferentes. Por eso en MideFinca cada encargo se presupuesta de forma individual, después de una primera valoración con los datos de la finca.",
      factorsH: "¿De qué depende el precio de medir una finca?",
      factors: [
        { title: "Superficie de la finca", text: "A más metros, más puntos que medir y más tiempo de campo. No pesa lo mismo un solar urbano que veinte hectáreas de rústica." },
        { title: "Ubicación y desplazamiento", text: "No requiere lo mismo una finca en un valle accesible que un paraje de Anaga o de Teno con largo desplazamiento." },
        { title: "Accesibilidad", text: "Si no hay acceso rodado o hay que llegar caminando con el equipo, el trabajo de campo se alarga." },
        { title: "Orografía del terreno", text: "Pendientes fuertes, barrancos y desniveles exigen más estaciones y más cuidado en la toma de puntos." },
        { title: "Vegetación y visibilidad", text: "La maleza densa o el arbolado cierran la señal GNSS y obligan a combinar equipos o a despejar zonas de trabajo." },
        { title: "Número y claridad de los linderos", text: "Una parcela con cuatro vértices claros no es lo mismo que una finca con veinte linderos discutidos o sin señalizar." },
        { title: "Documentación existente", text: "Escritura, planos antiguos o referencia catastral permiten preparar el trabajo antes de salir al campo." },
        { title: "Finalidad del trabajo", text: "No es lo mismo una comprobación orientativa que una medición destinada a un expediente catastral, notarial o judicial." },
        { title: "Precisión y alcance necesarios", text: "Determinar solo la superficie, o además replantear vértices, dibujar plano, comparar con Catastro o generar un GML." },
        { title: "Entregables", text: "Plano, memoria técnica, archivo GML, informe comparativo o certificado: cada entregable suma trabajo de gabinete." },
      ],
      factorsFoot: "Lo mismo ocurre con trabajos relacionados: georreferenciar una finca, elaborar un archivo GML, comprobar linderos o preparar la documentación para corregir datos de Catastro son trabajos cuyo coste depende de la complejidad técnica y del alcance concreto del encargo, no de una tarifa fija.",
      inclH: "¿Qué incluye el presupuesto?",
      inclP1: "El presupuesto se prepara según el trabajo realmente necesario para tu caso: la medición o visita técnica, la documentación a elaborar (plano, memoria, GML, certificado) y las comprobaciones catastrales o registrales que correspondan.",
      inclP2: "Antes de presupuestar realizamos una valoración inicial con los datos de la finca. Recibirás un presupuesto cerrado, por escrito, que detalla qué se va a hacer, qué recibirás y cuánto cuesta, antes de que decidas nada.",
      needH: "¿Qué necesitamos para darte presupuesto?",
      need: [
        "La referencia catastral, si la tienes. Si no, no pasa nada.",
        "La ubicación de la finca o un enlace de Google Maps.",
        "Qué necesitas o qué problema tienes, contado con tus palabras.",
        "Documentación si la tienes a mano: escritura, plano o captura de Catastro.",
        "Tu nombre y un teléfono o email de contacto.",
      ],
      exLead: "No hace falta que conozcas el trámite ni el término técnico. Vale con escribir algo como:",
      examples: [
        "Los metros de Catastro no coinciden con mi escritura",
        "No sé exactamente dónde termina mi terreno",
        "Quiero medir una finca que voy a comprar",
        "Me han pedido un GML",
      ],
      ctaH: "Pide tu presupuesto",
      ctaText: "Envíanos la referencia catastral, la ubicación de la parcela o cuéntanos brevemente qué necesitas. Estudiaremos tu caso para determinar qué trabajo necesitas y prepararte un presupuesto.",
      ctaBudget: "Solicita presupuesto",
      ctaRef: "Envíanos la referencia catastral",
    },
    about: {
      seoT: "Sobre MideFinca: estudio técnico de fincas en Canarias",
      seoD: "Quién está detrás de MideFinca, cómo trabajamos y qué criterios técnicos aplicamos en cada medición, GML o certificado en Canarias.",
      kicker: "Sobre MideFinca",
      h1: "Un estudio técnico",
      intro: "MideFinca nace con una especialización: medición, Catastro y documentación técnica de fincas e inmuebles en Canarias. Aportamos la base técnica sobre la que se apoyan propietarios, notarios, registradores, abogados y arquitectos: la medición, los planos, el informe, la corrección catastral y el certificado.",
      whoH: "Quién está detrás",
      dtLabel: "Dirección técnica:",
      whoP1: "{qualification} colegiado en el {collegiate}.",
      whoP2: "Trabajo de campo propio en las islas: medición con receptores GNSS y estación total, cartografía y documentación técnica de fincas e inmuebles.",
      principlesH: "Cómo nos gusta trabajar",
      principles: [
        { n: "01", title: "Claridad", text: "Te contamos qué pasa con tu finca en palabras normales. El rigor queda en el documento técnico; la conversación, en terreno llano." },
        { n: "02", title: "Transparencia", text: "Cuando un resultado depende de Catastro, notaría o Registro, te lo contamos desde el principio, para que sepas qué esperar en cada paso." },
        { n: "03", title: "Presupuesto", text: "Cada encargo empieza con un presupuesto cerrado: sabes qué se va a hacer, qué recibirás y cuánto cuesta antes de decidir." },
      ],
      processH: "Cómo se desarrolla cada encargo",
      ctaT: "¿Hablamos de tu finca?",
      ctaX: "Cuéntanos tu caso y te decimos con franqueza qué trabajo técnico necesita, si lo necesita.",
      imgAlt: "Técnico de MideFinca midiendo una finca con receptor GNSS en Canarias",
    },
    professionals: {
      seoT: "Colaboración técnica para profesionales en Canarias | MideFinca",
      seoD: "Apoyo técnico para arquitectos, abogados, inmobiliarias e ingenierías en Canarias: levantamientos, mediciones, georreferenciación, GML y documentación técnica de fincas.",
      kicker: "Profesionales · B2B",
      h1: "Apoyo técnico de medición para tu despacho o empresa",
      intro: "MideFinca presta apoyo técnico puntual o recurrente a profesionales del sector inmobiliario en Canarias: levantamientos, mediciones, georreferenciación, planos, comprobaciones y documentación técnica. Tú mantienes la relación con tu cliente; nosotros resolvemos la parte de campo y medición.",
      audiences: [
        { title: "Arquitectos y arquitectos técnicos", text: "Levantamientos topográficos georreferenciados como base de proyecto, mediciones de estado actual, planos en CAD y GML para la documentación gráfica de tus expedientes." },
        { title: "Abogados", text: "Mediciones e informes técnicos objetivos como prueba pericial de parte en conflictos de linderos, superficie o cabida. Datos medidos y trazables que sostienen tu argumentación." },
        { title: "Inmobiliarias y agentes", text: "Comprobación de superficie y límites antes de poner una finca a la venta: evita operaciones bloqueadas por discrepancias catastrales y ofrece a tus clientes datos reales." },
        { title: "Ingenierías y constructoras", text: "Apoyo en levantamientos, replanteos y control geométrico puntual o recurrente, con equipos GNSS propios y entrega en los formatos que uses." },
        { title: "Gestorías y otros profesionales", text: "Si tu cliente tiene un problema de superficie, Catastro o documentación técnica de su inmueble, resolvemos la parte de campo y medición para que tú completes la gestión." },
      ],
      collabH: "Colaboración profesional",
      collabText: "Trabajo puntual por encargo o colaboración recurrente. Presupuesto cerrado por trabajo y comunicación directa con el técnico.",
      collabCta: "Solicitar colaboración profesional",
      ctaT: "¿Trabajas con inmuebles en Canarias?",
      ctaX: "Cuéntanos qué tipo de apoyo técnico necesitas y te confirmamos plazos y presupuesto.",
    },
    legal: {
      updated: "Última actualización:",
    },
  },

  // Inglés: traducción completa (redactada por el agente, pendiente de
  // revisión de la titular).
  en: {
    nav: {
      home: "Home",
      services: "Services",
      problems: "Problems",
      guides: "Guides",
      professionals: "Professionals",
      about: "About MideFinca",
      contact: "Contact",
      quote: "Request a quote",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      mainAria: "Main navigation",
      mobileAria: "Mobile navigation",
      langAria: "Switch language",
    },
    crumbs: {
      aria: "Breadcrumb",
      home: "Home",
      services: "Services",
      problems: "Problems",
      guides: "Guides",
      prices: "Prices",
      professionals: "Professionals",
      about: "About MideFinca",
      contact: "Contact",
    },
    common: {
      tellCase: "Tell us about your case",
      quote: "Request a quote",
      whatsapp: "Ask on WhatsApp",
      floatWhats: "Ask a technician",
      allServices: "See all services",
      allGuides: "All guides",
      readGuide: "Read guide",
      seePage: "View page",
      inPrep: "In preparation",
      priceDepLink: "See what the price of surveying a plot depends on",
      relatedServices: "Related services",
      relatedProblems: "Related problems",
      relatedGuides: "Related guides",
      seeServices: "See services",
    },
    footer: {
      tagline: "We measure your plot. We make your paperwork easier.",
      servicesH: "Services",
      servicesAria: "Services",
      problemsH: "Problems",
      problemsAria: "Common problems",
      prices: "Prices & quotes",
      legal: "Legal notice",
      privacy: "Privacy policy",
      cookies: "Cookie policy",
      cookieSettings: "Cookie settings",
      seeAllProblems: "See all problems",
    },
    cta: {
      label: "Let's talk about your case",
      title: "Do you have a problem with a plot or property?",
      text: "Tell us about your case and we'll review what technical work it needs. No obligation, with a quote upfront.",
    },
    priceCta: {
      title: "Want to know how much it would cost in your case?",
      text: "The price depends on the characteristics of the plot and the work required. Send us the cadastral reference or the location and we can make an initial assessment.",
    },
    home: {
      seoT: "MideFinca | Plot surveying, Catastro and technical services in the Canary Islands",
      seoD: "We measure, verify and document land and buildings in the Canary Islands: plot surveying, GML files, georeferencing, Catastro discrepancies, new construction and certificates of age.",
      kicker: "Technical services for plots and properties · Canary Islands",
      h1l1: "Surveying and technical",
      h1l2: "solutions for plots",
      h1l3a: "and properties in the",
      h1l3b: "Canary Islands",
      intro: "We measure, verify and document land and buildings to resolve Catastro and Land Registry procedures and other formalities related to your property.",
      imgAlt: "MideFinca technician surveying a plot with a GNSS receiver in the Canary Islands",
      geo: "CANARY ISLANDS · UTM 28R · SPAIN",
      probKicker: "Common problems",
      probTitle: "Start with your problem, not with the name of the service",
      problems: [
        { title: "Catastro and title deed don't match", excerpt: "Two different figures for the same plot. Reality gets measured.", href: "/problemas/catastro-escritura-no-coinciden/" },
        { title: "I don't know where my boundaries are", excerpt: "Lost markers, moved walls, ambiguous adjoining boundaries.", href: "/problemas/no-se-donde-termina-mi-finca/" },
        { title: "My plot has more or fewer square metres", excerpt: "Doubt isn't solved with more paperwork: it's solved by measuring.", href: "/problemas/mi-finca-tiene-mas-o-menos-metros/" },
        { title: "I need a GML file", excerpt: "The georeferenced file notaries and the Land Registry ask for.", href: "/problemas/necesito-gml/" },
        { title: "Buying a plot with confidence", excerpt: "Check the square metres and the boundaries before you sign.", href: "/problemas/comprar-finca-comprobar-superficie/" },
        { title: "I want to declare a construction", excerpt: "Surveying, plans and certificate for new construction.", href: "/servicios/declaracion-obra-nueva/" },
        { title: "Undocumented extension", excerpt: "Your home has more square metres than the paperwork says.", href: "/problemas/construccion-no-documentada/" },
        { title: "Proving the age of a building", excerpt: "Technical certificate with historical evidence.", href: "/servicios/certificado-antiguedad/" },
      ],
      servKicker: "Services",
      fincasH: "Plots & land",
      edifH: "Buildings",
      procKicker: "How we work",
      procTitle: "Six steps, zero surprises",
      convLabel: "Individual quote",
      convTitle: "Need to survey a plot or solve a Catastro problem?",
      convText: "Send us the cadastral reference, the plot location or briefly tell us what you need. You don't need to know the procedure or the technical term: we'll study your case to determine what work it requires.",
      guidesKicker: "Guides",
      guidesH: "Understand your case before you decide",
      faqKicker: "Frequently asked questions",
      faqH: "What people ask us before calling",
    },
    process: {
      steps: [
        { n: "01", title: "Tell us about your case", text: "By phone, WhatsApp or the form. If you have the cadastral reference or the title deed, even better: we review the information before discussing it." },
        { n: "02", title: "We review the information", text: "We cross-check Catastro, mapping and the available documentation to understand what is happening and what needs correcting." },
        { n: "03", title: "We tell you what work is needed", text: "Once we have reviewed your case, we explain what technical work you need, what documentation we will prepare and what the scope of the assignment will be. You will receive a clear proposal together with the corresponding quote before we start." },
        { n: "04", title: "Surveying and site visit", text: "Once the quote has been accepted and the advance payment or retainer indicated to begin the assignment has been paid, we schedule the technical visit when the work requires it. We measure on site with GNSS equipment and total station and gather the information needed to prepare the documentation." },
        { n: "05", title: "We prepare the documentation", text: "Plans, technical report, GML file, cadastral amendment or technical certificate, depending on the assignment, with measured and georeferenced data." },
        { n: "06", title: "Delivery of the technical work", text: "When the work is finished, we let you know the documentation is ready. Once the outstanding fees have been paid, we make the full handover and explain what documentation you receive, what it is for and what the next steps are, if any." },
      ],
    },
    trust: {
      kicker: "Why MideFinca",
      title: "Technical rigour, explained in plain words",
      points: [
        { title: "Chartered architect", text: "Technical direction is provided by an architect registered with the Official College of Architects of Tenerife, La Gomera and El Hierro." },
        { title: "Professional surveying equipment", text: "We work with GNSS receivers and total stations to obtain georeferenced measurements." },
        { title: "Fixed quote upfront", text: "Before we start you know what will be done, what you will receive and how much it costs. No surprises." },
        { title: "Professional technical documentation", text: "Plans, reports, GML files and certificates produced with technical judgement, not generic templates." },
        { title: "Real work in the Canary Islands", text: "We know the territory, the island mapping and the Catastro casuistry of the Canary Islands." },
        { title: "No empty promises", text: "We tell you what is viable and what depends on third parties. If your case has no technical path forward, we tell you before charging you anything." },
      ],
    },
    need: {
      kicker: "What do you need to sort out?",
      knowT: "I know what I need",
      knowText: "You know the service: a survey, a GML file, a certificate. Choose directly.",
      probT: "I have a problem",
      probText: "You don't know which service is needed. Tell us what's going on and we'll guide you.",
      probLink: "I don't know what I need: I'll explain my case",
    },
    marquee: {
      items: [
        "Plot surveying",
        "Catastro",
        "Georeferencing",
        "GML files",
        "Boundary checks",
        "New construction",
        "Certificate of age",
        "Habitability",
        "Topographic surveys",
        "Land Registry",
      ],
    },
    thanks: {
      seoT: "We have received your case | MideFinca",
      seoD: "We have received your enquiry. We will review it and get back to you as soon as possible.",
      h1: "We have received your case",
      text: "We will review the information you sent us, including the cadastral reference if you provided it, and contact you to confirm what technical work your case needs and its quote.",
      urgent: "If it is urgent, you can call or write to us directly:",
      back: "Back to home",
    },
    notFound: {
      seoT: "Page not found | MideFinca",
      seoD: "We can't find that page. Go to services, common problems, guides or contact.",
      h1: "We can't find that page",
      text: "The address may be misspelled or the content may have moved. This is what most visitors are looking for:",
      navAria: "Main destinations",
      links: [
        { label: "Technical services", href: "/servicios/" },
        { label: "Common problems", href: "/problemas/" },
        { label: "Guides", href: "/guias/" },
        { label: "Contact", href: "/contacto/" },
      ],
    },
    contact: {
      seoT: "Contact: plot surveying in the Canary Islands | MideFinca",
      seoD: "Tell us about your case: plot surveying, GML files, Catastro discrepancies, new construction or certificates of age in the Canary Islands. Phone, WhatsApp and form.",
      kicker: "Contact",
      h1: "Tell us about your case",
      intro: "You don't need to know which service you need. Describe your problem in your own words and we'll tell you what technical work applies, with an upfront quote and no obligation.",
      phoneL: "Phone",
      whatsNote: "Direct reply from the technician",
      emailL: "Email",
      areaL: "Service area",
      areaV: "Canary Islands",
      refNote: "Do you have the cadastral reference at hand? Include it in the form: it lets us review your plot's mapping before replying.",
      photoAlt: "MideFinca technician surveying a plot with a GNSS receiver",
    },
    form: {
      name: "Name",
      namePh: "Your name",
      phone: "Phone",
      email: "Email",
      municipality: "Municipality",
      municipalityPh: "Select your municipality",
      other: "Other (outside the Canary Islands)",
      need: "What do you need?",
      needPh: "Select an option",
      message: "Briefly describe your case",
      messagePh: "E.g.: Catastro shows 1,200 m² but the deed says 1,500 m². I want to sell and need to know the real surface area.",
      refcat: "Cadastral reference",
      optional: "(optional)",
      attach: "Attach documentation",
      attachHint: "(optional · PDF, JPG, PNG · max. 10 MB)",
      chooseFile: "Choose file",
      honeypot: "Do not fill in",
      privLead: "Basic data protection information:",
      privResponsible: "Controller:",
      privPurpose: "Purpose: to handle your enquiry, assess the case and prepare a quote",
      privLegit: "Legal basis: pre-contractual measures",
      privRecipients: "Recipients: your data will not be disclosed except under legal obligation or when the requested service requires it",
      privRights: "Rights: access, rectification, erasure, objection, restriction and portability",
      privMore: "More information in the",
      privLink: "privacy policy",
      accept: "I have read and accept the",
      sending: "Sending…",
      error: "Something went wrong. Please try again or call us.",
    },
    cookies: {
      bannerAria: "Cookie consent",
      bannerA: "We use technical storage necessary for the website to work and, only if you authorise it, analytics cookies (Google Analytics 4) to measure site usage. You can accept, reject or configure your choice, and change it later from «Cookie settings» in the footer. More information in the",
      bannerLink: "cookie policy",
      accept: "Accept",
      reject: "Reject",
      configure: "Settings",
      panelAria: "Cookie settings",
      panelTitle: "Cookie settings",
      close: "Close settings",
      techT: "Technical (necessary)",
      techText: "Essential local storage: it remembers your cookie choice and keeps the private management panel session. These are exempt from consent.",
      alwaysOn: "Always on",
      analyticsT: "Analytics",
      analyticsText: "Google Analytics 4: anonymous measurement of website usage.",
      analyticsOff: "There is currently no analytics configured: this category remains inactive.",
      enable: "Enable",
      save: "Save selection",
      rejectAll: "Reject all",
    },
    servicesHub: {
      seoT: "Technical services for plots and properties in the Canary Islands | MideFinca",
      seoD: "Plot surveying, topographic surveys, georeferencing, GML files, boundary checks, cadastral discrepancies, new construction, certificates of age and habitability in the Canary Islands.",
      kicker: "Services",
      h1: "Technical services for plots and properties",
      intro: "Surveying, Catastro and technical documentation. If you're not sure which one you need, tell us your problem and we'll guide you with no obligation.",
      fincasH: "Plots & land",
      edifH: "Buildings",
    },
    problemsHub: {
      seoT: "Problems with plots and Catastro: technical solutions | MideFinca",
      seoD: "Catastro and deed don't match? Don't know where your plot ends? Been asked for a GML file? A clear diagnosis of each problem and the technical work that solves it.",
      kicker: "Common problems",
      h1: "Start with your problem",
      intro: "Most of our clients don't know which service they need: they know what's happening to them. Find your situation and we'll explain the causes, what to check and what technical work applies.",
      ctaT: "Can't find your problem?",
      ctaX: "Every plot is a case of its own. Tell us yours in your own words and we'll tell you what technical work it needs, if it needs any.",
    },
    guidesHub: {
      seoT: "Guides on Catastro, surveying and plot documentation | MideFinca",
      seoD: "Technical guides written in plain language: real surface areas, discrepancies between Catastro and deeds, GML files, boundaries, new construction and certificates of age in the Canary Islands.",
      kicker: "Guides",
      h1: "Technical guides, written in plain language",
      introA: "Reviewed technical content, no filler. We publish a guide when it is finished and verified, not before. Categories:",
      relatedH: "You may also be interested in",
      ctaT: "Is your question not in the guides?",
      ctaX: "Ask us directly. If it's a recurring topic, it will probably end up becoming a guide.",
    },
    servicePage: {
      fincas: "Plots & land",
      edif: "Buildings",
      b1: "When you need this service",
      b2: "What problem it solves",
      b3: "What's included",
      b4: "What we need to assess your case",
      b5: "What you will receive",
      b6: "Frequently asked questions",
    },
    problemPage: {
      kicker: "Common problem",
      answer: "The short answer",
      causes: "Possible causes",
      checks: "What needs checking",
      pros: "Which professionals are involved",
      serviceH: "The MideFinca service that may fit",
      serviceNote: "It depends on the specific case: we review your documentation first and then confirm it.",
    },
    guidePage: {
      updated: "Updated:",
      yourCase: "Is this your case?",
    },
    prices: {
      seoT: "How much does it cost to survey a plot in the Canary Islands? | MideFinca",
      seoD: "The price of surveying a plot depends on the surface area, location, terrain and the work required. We explain what it depends on and what we need to give you a fixed quote.",
      kicker: "Prices & quotes",
      h1: "How much does it cost to survey a plot in the Canary Islands?",
      intro: "If you're looking for the price of surveying a plot or piece of land in the Canary Islands, the honest answer is that there is no single rate: two plots with the same surface area can require very different work. That's why at MideFinca every assignment is quoted individually, after an initial assessment with the plot's data.",
      factorsH: "What does the price of surveying a plot depend on?",
      factors: [
        { title: "Plot surface area", text: "More square metres means more points to measure and more fieldwork time. A city building plot is not the same as twenty hectares of rural land." },
        { title: "Location and travel", text: "A plot in an accessible valley is not the same as a spot in Anaga or Teno with a long journey." },
        { title: "Accessibility", text: "If there is no road access or we have to walk in with the equipment, the fieldwork takes longer." },
        { title: "Terrain", text: "Steep slopes, ravines and elevation changes require more stations and more care when taking points." },
        { title: "Vegetation and visibility", text: "Dense scrub or tree cover blocks the GNSS signal and forces us to combine equipment or clear work areas." },
        { title: "Number and clarity of boundaries", text: "A parcel with four clear vertices is not the same as a plot with twenty disputed or unmarked boundaries." },
        { title: "Existing documentation", text: "Deeds, old plans or the cadastral reference allow us to prepare the work before going into the field." },
        { title: "Purpose of the work", text: "An indicative check is not the same as a survey intended for a cadastral, notarial or judicial procedure." },
        { title: "Required precision and scope", text: "Determining only the surface area, or also setting out vertices, drawing plans, comparing with Catastro or generating a GML file." },
        { title: "Deliverables", text: "Plan, technical report, GML file, comparative report or certificate: each deliverable adds office work." },
      ],
      factorsFoot: "The same applies to related work: georeferencing a plot, producing a GML file, checking boundaries or preparing documentation to correct Catastro data are jobs whose cost depends on the technical complexity and the specific scope of the assignment, not on a fixed rate.",
      inclH: "What does the quote include?",
      inclP1: "The quote is prepared according to the work actually needed for your case: the survey or site visit, the documentation to be produced (plan, report, GML, certificate) and the cadastral or registry checks that apply.",
      inclP2: "Before quoting we carry out an initial assessment with the plot's data. You will receive a fixed quote, in writing, detailing what will be done, what you will receive and how much it costs, before you decide anything.",
      needH: "What do we need to give you a quote?",
      need: [
        "The cadastral reference, if you have it. If not, no problem.",
        "The location of the plot or a Google Maps link.",
        "What you need or what problem you have, in your own words.",
        "Documentation if you have it at hand: deed, plan or a Catastro screenshot.",
        "Your name and a contact phone number or email.",
      ],
      exLead: "You don't need to know the procedure or the technical term. Writing something like this is enough:",
      examples: [
        "Catastro's square metres don't match my deed",
        "I don't know exactly where my land ends",
        "I want to survey a plot I'm going to buy",
        "I've been asked for a GML file",
      ],
      ctaH: "Ask for your quote",
      ctaText: "Send us the cadastral reference, the plot location or briefly tell us what you need. We will study your case to determine what work it needs and prepare a quote for you.",
      ctaBudget: "Request a quote",
      ctaRef: "Send us the cadastral reference",
    },
    about: {
      seoT: "About MideFinca: technical studio for plots in the Canary Islands",
      seoD: "Who is behind MideFinca, how we work and what technical criteria we apply to every survey, GML file or certificate in the Canary Islands.",
      kicker: "About MideFinca",
      h1: "A technical studio",
      intro: "MideFinca was born with a specialisation: surveying, Catastro and technical documentation for plots and properties in the Canary Islands. We provide the technical foundation on which owners, notaries, registrars, lawyers and architects rely: the measurement, the plans, the report, the cadastral correction and the certificate.",
      whoH: "Who is behind it",
      dtLabel: "Technical direction:",
      whoP1: "{qualification} registered with the {collegiate}.",
      whoP2: "Our own fieldwork across the islands: surveying with GNSS receivers and total station, mapping and technical documentation for plots and properties.",
      principlesH: "How we like to work",
      principles: [
        { n: "01", title: "Clarity", text: "We explain what's going on with your plot in plain words. The rigour stays in the technical document; the conversation stays on level ground." },
        { n: "02", title: "Transparency", text: "When a result depends on Catastro, the notary or the Land Registry, we tell you from the start, so you know what to expect at each step." },
        { n: "03", title: "Quote", text: "Every assignment starts with a fixed quote: you know what will be done, what you will receive and how much it costs before you decide." },
      ],
      processH: "How every assignment unfolds",
      ctaT: "Shall we talk about your plot?",
      ctaX: "Tell us about your case and we'll honestly tell you what technical work it needs, if it needs any.",
      imgAlt: "MideFinca technician surveying a plot with a GNSS receiver in the Canary Islands",
    },
    professionals: {
      seoT: "Technical collaboration for professionals in the Canary Islands | MideFinca",
      seoD: "Technical support for architects, lawyers, real estate agencies and engineering firms in the Canary Islands: surveys, measurements, georeferencing, GML files and technical plot documentation.",
      kicker: "Professionals · B2B",
      h1: "Technical surveying support for your firm or company",
      intro: "MideFinca provides one-off or recurring technical support to real estate professionals in the Canary Islands: surveys, measurements, georeferencing, plans, checks and technical documentation. You keep the relationship with your client; we solve the fieldwork and measurement side.",
      audiences: [
        { title: "Architects and building engineers", text: "Georeferenced topographic surveys as a project base, measurements of existing conditions, CAD plans and GML files for the graphic documentation of your files." },
        { title: "Lawyers", text: "Objective measurements and technical reports as expert evidence in boundary, surface area or extent disputes. Measured, traceable data that supports your case." },
        { title: "Real estate agencies and agents", text: "Surface and boundary checks before listing a plot: avoid deals blocked by cadastral discrepancies and offer your clients real data." },
        { title: "Engineering firms and builders", text: "Support with surveys, setting out and one-off or recurring geometric control, with our own GNSS equipment and delivery in the formats you use." },
        { title: "Administrative agencies and other professionals", text: "If your client has a surface, Catastro or technical documentation problem with their property, we solve the fieldwork and measurement side so you can complete the management." },
      ],
      collabH: "Professional collaboration",
      collabText: "One-off work per assignment or recurring collaboration. Fixed quote per job and direct communication with the technician.",
      collabCta: "Request professional collaboration",
      ctaT: "Do you work with properties in the Canary Islands?",
      ctaX: "Tell us what kind of technical support you need and we'll confirm timings and quote.",
    },
    legal: {
      updated: "Last updated:",
      note: "Informative English version. For legal purposes, the Spanish text prevails.",
    },
  },
};
